import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { injectIntl, FormattedMessage } from "react-intl";
import { ConnectedPaginatedTable, CustomTableRow } from "components/table";
import query from "./query";
import styles from "./styles.css.js";
import withStyles from "components/with-styles";
import cn from "classnames";
import OptionalDate from "components/optional-date";
import PropTypes from "prop-types";
import { HeaderCell } from "components/table";
import {GENERAL_STATUS_KO} from "../../../../utils/constants";

const Header = () => (
  <TableRow>
    <HeaderCell>
      <FormattedMessage id="source.status" />
    </HeaderCell>
    <HeaderCell>
      <FormattedMessage id="app.page.source" />
    </HeaderCell>
    <HeaderCell />
    <HeaderCell />
  </TableRow>
);

const Row = ({ classes, intl, item }) => (
  <CustomTableRow
    key={item.id}
    href={`/source/details/${item.id}`}
    className={cn({ [classes.alert]: item.lastStatus === GENERAL_STATUS_KO })}
  >
    <TableCell>
      <div>{item.lastStatus}</div>
      <div className={cn({ [classes.alertText]: item.lastStatus === GENERAL_STATUS_KO })}>
        <OptionalDate value={item.lastChecked} />
      </div>
    </TableCell>
    <TableCell>{item.description}</TableCell>
    <TableCell>
      <div className={classes.title}>
        {item.brand} {item.model}
        <div className={classes.code}>{item.serial}</div>
      </div>
    </TableCell>
    <TableCell>
      <div>
        {item.type} ({item.use})
      </div>
      <div>{item.owner}</div>
    </TableCell>
  </CustomTableRow>
);

Row.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
};

const EventSourcesTable = ({ deploymentId, ...props }) => (
  <ConnectedPaginatedTable
    variables={{ deploymentId, offset: undefined, limit: undefined }}
    gqlQuery={query}
    headerComponent={Header}
    rowComponent={injectIntl(withStyles(styles)(Row))}
    paginatedElementsHandler={data => data.sources}
    showPagination={false}
    {...props}
  />
);

EventSourcesTable.propTypes = {
  /**
   ** Deployment id del evento
   **/
  deploymentId: PropTypes.string,
  /**
   ** Número de página a mostrar
   **/
  page: PropTypes.number,
};

export default EventSourcesTable;
